import AdminOrders from "../admin/Orders";
export default function VendorOrders() { return <AdminOrders />; }
